(function($){
  $( document ).ready(function() {
    'use strict';
  
    $( '[data-populate-field]' ).on('keyup', function(e) {
      var field = $(this).data('populate-field'),
          value = $(this).val();
  
          $('[name=input_' + field +']' ).val( value );
    });
  });
})(jQuery);
